﻿import { fieldsProxy } from "@serenity-is/corelib";

export interface FileSystemRow {
    Id?: number;
    FullPath?: string;
    Filename?: string;
    Extension?: string;
    Size?: number;
    IsDirectory?: boolean;
    ParentPath?: string;
    Metadata?: string;
    Contents?: number[];
    CreationTime?: string;
    LastWriteTime?: string;
}

export abstract class FileSystemRow {
    static readonly idProperty = 'Id';
    static readonly nameProperty = 'Filename';
    static readonly localTextPrefix = 'Pro.Extensions.FileSystem';
    static readonly deletePermission = null;
    static readonly insertPermission = null;
    static readonly readPermission = '';
    static readonly updatePermission = null;

    static readonly Fields = fieldsProxy<FileSystemRow>();
}